import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { toastr } from 'react-redux-toastr';
import { getCasinoGames, getSlotGameData } from '../../store/actions/casino.actions';
import Game from './Game';
import NewLoading from '../../Components/Common/NewLoading';
import InfiniteScroll from 'react-infinite-scroll-component';
import LoadingIcon from '../../Components/Common/LoadingIcon';
import Login from '../Login';
import Categories from './Categories';

const GameList = (props) => {
    const { category, provider_id, slug } = useParams();
    const dispatch = useDispatch();
    const history = useHistory();
    const [showLogin, setShowLogin] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [page, setPage] = useState(0);
    const { filteredCasinoGames, casinoSearchValue, filteredGamesCount, loadingCasinoGames } = useSelector((state) => state.casino);
    const userData = useSelector((state) => state.user.data);

    useEffect(() => {
        document.title = `${category ? category?.replace("_", " ") : provider_id ? provider_id?.replace("_", " "): slug ? slug?.replace("_", " ") : '' } - JackpotCT`;
        const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        `Play your favorite Online Casino table games, including
        blackjack, roulette, and baccarat, with real dealers in an
        immersive online environment`
      );
    }

      }, []);

    useEffect(() => {
        setPage(0);
    }, [casinoSearchValue]);

    useEffect(() => {
        let most_popular, latest, themes, feature;
        switch (slug) {
            case 'most_popular':
                most_popular = true;
                break;
            case 'new':
                latest = true;
                break;
            case 'chinese':
                themes = 'chinese';
                break;
            case 'bonus buy':
                feature = 'bonus buy';
                break;
            default:
            // code block
        }
        let filters = {
            category,
            provider_id,
            most_popular,
            latest,
            themes,
            feature,
            search: casinoSearchValue,
            page: page,
            size: 20
        };
        dispatch(getCasinoGames(filters));
    }, [page, casinoSearchValue]);

    const hideLogin = () => {
        setShowLogin(false);
    };

    const fetchMore = () => {
        if (filteredCasinoGames.length == filteredGamesCount) setHasMore(false);
        setPage(page + 1);
    };

    const isLoggedIn = () => {
        return userData !== null;
    };

    const playGame = (game, type) => {
        if (type == 'demo') {
            if (game?.demoSupport) {
                dispatch(getSlotGameData(game, type, history));
            } else {
                toastr.info("Please try another game this game dosn't support demo mode");
            }
        } else if (isLoggedIn()) {
            dispatch(getSlotGameData(game, type, history));
        } else {
            sessionStorage.setItem('gameData', JSON.stringify(game));
            setShowLogin(true);
        }
    };

    let gameList =
        filteredCasinoGames && filteredCasinoGames.length > 0
            ? filteredCasinoGames.map((game) => {
                return <Game game={game} playGame={playGame} />;
            })
            : [];

    return (
        <div id={!props.home && 'scrollableDiv'}>
            {!props.home && <div className='category-slider'> <Categories /> </div>}
            {loadingCasinoGames ? (
                <NewLoading customClass="casino-loader" />
            ) : filteredCasinoGames.length > 0 ? (
                <div className='slider-section'>
                    <div className="casino-game-parent pl-40 pr-40 clearfix mb-2">
                        <div className="tab-content" id="nav-tabContent">
                            <div className="tab-pane fade show active casino-box">
                                <div>
                                    <InfiniteScroll
                                        dataLength={filteredCasinoGames.length}
                                        next={() => fetchMore()}
                                        hasMore={hasMore}
                                        useWindow={false}
                                        loader={<LoadingIcon theme="dark centered" />}
                                        scrollableTarget="infinite-div"
                                        threshold={7}
                                        scrollThreshold={0.7}
                                    >
                                        <ul>{gameList}</ul>
                                    </InfiniteScroll>
                                </div>
                            </div>
                        </div>
                    </div>
                    {showLogin && <Login hideLogin={hideLogin} history={history} />}
                </div>
            ) : (
                <div className="nothing-found-casino text-white">Nothing Found</div>
            )}
        </div>
    );
};

export default GameList;